const upcomingTasks = [
    {
        id: 1,
        title: 'Entendi, segue foto e link para acesso ao __descrProduto__. 👍👍👍',
        date: '02 Maio, 2023',
        task: 'Mensagem',
        user: [require('@/assets/images/users/avatar-4.jpg'), require('@/assets/images/users/avatar-5.jpg')],
        budget: 145,
        groupId: 1
    },
    {
        id: 2,
        title: 'https://mobagile.com.br/products_cota/__codProduto__.jpg',
        date: '02 Maio, 2023',
        task: 'Imagem',
        user: [require('@/assets/images/users/avatar-6.jpg'), require('@/assets/images/users/avatar-7.jpg')],
        budget: 145,
        groupId: 1
    },
    {
        id: 3,
        title: 'Acesse e compre agora, https://pote-pink.vercel.app/produto/default/__codProduto__',
        date: '02 Maio, 2023',
        task: 'Link',
        user: [require('@/assets/images/users/avatar-5.jpg')],
        budget: 145,
        groupId: 1
    },
];

const progressTasks = [
    {
        id: 4,
        title: 'Entendi, localizei seu último pedido contendo o produto __descrProduto__. 👍👍👍',
        date: '03 Maio, 2023',
        task: 'Mensagem',
        user: [require('@/assets/images/users/avatar-6.jpg')],
        budget: 94,
        groupId: 2
    },
    {
        id: 5,
        title: 'Confirma repetir o mesmo pedido com o valor de R$ __valorPedido__',
        date: '03 Maio, 2023',
        task: 'Botoes',
        user: [require('@/assets/images/users/avatar-8.jpg'), require('@/assets/images/users/avatar-1.jpg')],
        budget: 94,
        groupId: 2
    },
    {
        id: 6,
        title: 'Muito obrigada, seu novo pedido SK00990 está disponível no link, clique e acesse ♥',
        date: '03 Maio, 2023',
        task: 'Link',
        user: [require('@/assets/images/users/avatar-2.jpg')],
        budget: 94,
        groupId: 2
    },
];

const completedTasks = [
    {
        id: 7,
        title: 'Entendi, nosso horário de funcionamento é de segunda a sexta feira de 08:00 até 18:00, Obrigado por perguntar ♥',
        date: '04 Maio, 2023',
        task: 'Mensagem',
        user: [require('@/assets/images/users/avatar-4.jpg')],
        budget: 145,
        groupId: 3
    },
];

export { upcomingTasks, progressTasks, completedTasks };

